import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import * as Scroll from 'react-scroll';
import { Link, DirectLink, Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebar: false,
      activeClass: 'home',
    }
    this.passHook = this.passHook.bind(this);
  }z

  passHook(activeClass) {
    this.setState({ activeClass: activeClass });
  }

  updateClass(activeClass) {
    if (this.state.activeClass !== activeClass && this.props.hookNav) {
      this.setState({ activeClass });
      this.props.hookNav(activeClass);
    }
  }
  
  render() {
    const navigationLinks = this.props.data.map((li, i) => {
      let offset = 0;
      switch (li.id) {
        case 'contact':
          offset = 0;
          break;
        default:
          break;
      }
      
      return (
        <li key={i}><Link onSetActive={(to) => {
          this.updateClass(to);
        }} to={li.id} spy={true} hashSpy={true} ignoreCancelEvents={false} isDynamic={true} offset={offset} smooth={true} duration={500} className={`${this.state.activeClass === i ? 'active' : ''} unline white`} href={li.id ? '#' + li.id : '#'}>{li.name ? li.name : ''}</Link></li>
      )
    });

    return (
      <Fragment>
        {this.props.type === 'header' && 
        <header id="header" className={`header header-fixed st-effect`}>
          <div className="wrapper" id="header-wrapper">
            <h1 className="logo">
              <a href="#">Huibert Van Dorp maps</a>
            </h1>

            <nav className="menu">
              <ul className="list">
                { this.props.data.map((li, i) => {
                  return (
                    <li key={i}><a
                      onClick={(e) => {
                        e.preventDefault();
                        scroller.scrollTo(li.id, {
                          duration: 500,
                          smooth: true
                        });
                      }}
                      className={`${this.state.activeClass === li.id ? 'active' : ''} unline white`} href={li.id ? '#' + li.id : '#'}>{li.name ? li.name : ''}</a></li>
                  )
                })}
              </ul>
            </nav>
          </div>
        </header>
        }
        
        {this.props.type === 'sidebar' &&
        <div className="sidebar-wrap-helper">
          <aside id="sidebar" className={`header st-menu st-effect`}>
            <div className="wrapper">
              <span className="logo">
                <a href="#">Huibert Van Dorp maps</a>
              </span>

              <nav className="menu">
                <ul className="list">
                  {navigationLinks}
                </ul>
              </nav>
            </div>
            <div className="burger-handler" onClick={this.props.toggleNav}>
              <button><i className="fas fa-bars"></i></button>
            </div>
            <div className="curtain"></div>
          </aside>
        </div>
        }
      </Fragment>
    )
  }
}
Header.defaultProps = {}

Header.propTypes = {}


// WEBPACK FOOTER //
// ./src/components/Header.js